module.exports = __webpack_public_path__ + "static/media/google-logo.00489c37.svg";